import React from 'react';
import { useExamType } from '../contexts/ExamTypeContext';
import './LegalPages.css';

const Support: React.FC = () => {
  const { getExamTypeName } = useExamType();
  
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Support & Contact</h1>
        <p className="last-updated">We're here to help you succeed in your German citizenship journey.</p>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions, feedback, or need assistance with our Leben in Deutschland Test Preparation app, 
            please don't hesitate to reach out to us. We value your input and are committed to providing 
            the best possible experience.
          </p>
          <div className="contact-info">
            <p><strong>Email Support:</strong> <a href="mailto:muhammad.aref.ali.hamada@gmail.com">muhammad.aref.ali.hamada@gmail.com</a></p>
            <p><strong>Response Time:</strong> We aim to respond to all inquiries within 2-3 business days.</p>
          </div>
        </section>

        <section>
          <h2>Frequently Asked Questions (FAQ)</h2>
          
          <h3>How many questions do I need to answer correctly?</h3>
          <p>
            To pass the Leben in Deutschland test (Einbürgerungstest), you need to answer at least 17 out of 33 
            questions correctly. The exam consists of 30 questions from the general pool and 3 questions specific 
            to your German state (Bundesland).
          </p>

          <h3>Which questions will appear on my exam?</h3>
          <p>
            The official test randomly selects 33 questions from a pool of 300 general questions plus 10 
            state-specific questions. Our app includes all of these questions so you can study everything that 
            might appear on your exam.
          </p>

          <h3>Can I study in my own language?</h3>
          <p>
            Yes! Our app supports 8 languages: German, English, Arabic, Spanish, French, Russian, Turkish, and Farsi. 
            You can toggle between German-only view and bilingual view to help you learn. However, note that the 
            actual exam will be in German only.
          </p>

          <h3>How do I save my progress?</h3>
          <p>
            Your progress is automatically saved to your device. If you create an account and sign in, 
            your progress will be synced to the cloud, allowing you to access it across multiple devices 
            and ensuring your data is safe even if you reinstall the app.
          </p>

          <h3>Is the app free to use?</h3>
          <p>
            The app offers free access to all 300 questions with basic features. Premium features (ad-free, 
            offline access, advanced analytics) may require a subscription, which helps us maintain and improve 
            the app and continue providing translations in 8 languages.
          </p>

          <h3>I found a mistake in a translation or explanation. What should I do?</h3>
          <p>
            The official questions are from BAMF (German government). However, if you spot an error in our 
            translations or explanations, please email us with details (screenshot or question number). 
            We appreciate your help in improving the quality for everyone.
          </p>
          
          <h3>Which German state should I select?</h3>
          <p>
            Select the Bundesland (German state) where you will take your citizenship test. This ensures you 
            see the correct state-specific questions. You can change your selected state anytime in the app settings.
          </p>

          <h3>Is this the official exam?</h3>
          <p>
            No, this is a preparation app. The official Leben in Deutschland test must be taken at an authorized 
            test center. Our app helps you prepare by providing all official questions with explanations and practice exams.
          </p>
        </section>

        <section>
          <h2>Troubleshooting</h2>
          
          <h3>Images are not loading</h3>
          <p>
            Some questions include images (especially state-specific questions). Ensure you have a stable internet 
            connection. Premium users can download all content for offline access. If images still don't load, 
            try restarting the app.
          </p>

          <h3>App is crashing or freezing</h3>
          <p>
            Ensure you have the latest version of the app installed from the App Store or Google Play. 
            If the problem continues, try clearing the app cache or reinstalling. Please contact support 
            if the issue remains.
          </p>

          <h3>Translations are not showing</h3>
          <p>
            Make sure you've selected your preferred interface language in the app settings. You can also use 
            the translation toggle button when viewing questions to show/hide translations.
          </p>
        </section>

        <section>
          <h2>Data Privacy</h2>
          <p>
            We take your privacy seriously. For details on how we handle your data, please review our 
            <a href="/privacy"> Privacy Policy</a> and <a href="/data-deletion"> Data Deletion</a> instructions.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Support;

